import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './index.css';
import { Provider } from 'react-redux';
import Store from './redux/Store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={Store}>
            <App />
        </Provider>
    </React.StrictMode>
);


// source: https://www.youtube.com/watch?v=9MMSRn5NoFY
// saga crud: https://github.com/itsmaheshkariya/react-redux-saga-crud-app/tree/master/src